import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPrograms } from '../../src/actions/programs';
import { fetchAvailablePrograms } from '../../src/actions/availablePrograms';
import Layout from '../../src/components/Layout';
import Header from '../../src/components/Header';
import UserProgramsContent from '../../src/containers/Pages/Programs/Purchased';
import PageLoader from 'components/PageLoader';
import { SessionAuth } from 'supertokens-auth-react/recipe/session';

const Programs = props => {
  const dispatch = useDispatch();
  const isProgramsLoading = useSelector(state => state.programs.loading);

  useEffect(() => {
    dispatch(fetchPrograms());
    dispatch(fetchAvailablePrograms());
  }, []);

  return (
    <SessionAuth>
      <Layout title="Programs | GMB Fitness™">
        <Header backTo="/" backTitle="Home" />
        {isProgramsLoading ? <PageLoader /> : <UserProgramsContent />}
      </Layout>
    </SessionAuth>
  );
};

export default Programs;
